import React, { PureComponent } from 'react';

import uuid from 'uuid/v4';

import { Endpoint, IeDocument, IeStatus, ieTabela, IeUndeterminedValidity, ProviderAccreditationFileService, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { Card, Checkbox, DateField, Field, FileUploader, Form, Input, Stamp, Text, Token } from '@philips-emr/tws-components';
import { Type } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener } from '@philips-emr/tws-core/lib/component/prop-types';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import HpmsDocumentCardApi from '../../api/hpms-documents-card/hpms-documents-card-api';
import AttachmentsList from '../attachments-list/attachments-list';

import './hpms-documents-card.scss';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsDocumentCardApi })
export default class HpmsDocumentsCard extends PureComponent {

  static propTypes = {
    onAfterSubmitDocumentsCard: eventListener,
    onMountDocumentsCard: eventListener,
  }

  state = {
    editForm: false,
    loading: false,
    record: {},
  };

  componentDidMount() {
    this.setState({ record: this.props });
  }

  renderCard() {
    const { record: data } = this.state;

    const checkBoxValid = data.ieExpirationDt === IeDocument.I ? true : false;
    const isMandatoryExpirationDate = data.ieExpirationDt === IeDocument.O || data.ieExpirationDt === IeDocument.I ? true : false;
    const isMandatoryIssueDate = data.ieIssueDt === IeDocument.O ? true : false;
    const isValidAttachment = !data.nrSeqAttachment ? false : true;
    const isAttachment = !!data.filename || this.state.editForm;
    const validIssueDt = data.ieIssueDt === IeDocument.N;
    const validCheckbox = data.ieStatusCheck;
    const validExpirationDt = data.ieExpirationDt === IeDocument.N || validCheckbox;
    const locked = data.editable == 'N';
    const typeDocSize = data.mandatory === 'S' ? 5 : 9;

    const predefinedAttachments = {
      key: String(data.nrSeqTypeDoc),
      value: data.dsDocument,
    };

    let attachmentDetail = {};

    if(data.nrSeqAttachment) {
      attachmentDetail = {
        label: data.filename,
        nrSeqAttachment: data.nrSeqAttachment,
        filename: data.filename,
        filepath: data.filepath,
      };
    }

    if(data.attachments && !isEmptyArrayOrObject(data.attachments)) {
      attachmentDetail = data.attachments[0];
      attachmentDetail.label = attachmentDetail.filename;
      attachmentDetail.nrSeqAttachment = null;
    }

    const isEmpty = isEmptyArrayOrObject(attachmentDetail);

    return (
      <Card width={12} uuid={uuid()} className="hpms-card-document-style" ieStatus={data.ieStatus} superscriptionEntry="ieStatus" superscription={this.getSupercriptions()}>
        <Form
          loading={this.state.loading}
          locked={locked}
          editing={locked ? !locked : this.state.editForm}
          data={data}
          uuid={uuid()}
          className="form-document-style"
          onEdit={() => this.setState({ editForm: true })}
          onCancel={() => this.onCancel()}
          onChange={(event) => this.onChange(event)}
          onSubmit={(event) => this.onSubmit(event)}>
          <Field width={isValidAttachment || this.state.editForm ? 3 : typeDocSize} uuid={uuid()} alwaysShowLabel label="pa.document" entry="dsDocument">
            <Text />
          </Field>
          <Field width={4} uuid={uuid()} alwaysShowLabel label="pa.attachment" entry="filename" visible={isAttachment}>
            { !isEmpty || data.attachments ? <AttachmentsList uuid={uuid()} data={[attachmentDetail]} onSelect={(event) => this.onSelect(event)} /> : <Text />}
          </Field>
          <Field width={4} uuid={uuid()} visible={this.state.editForm} entry="attachments">
            <FileUploader uuid={uuid()} enabled={true} valid={true} predefinedFiles={[predefinedAttachments]} />
          </Field>
          {this.state.editForm
            ? <Field width={2} uuid={uuid()} alwaysShowLabel label="pa.issue-date" entry="issueDt" validators={this.getValidatorIssueDate(isMandatoryIssueDate)}>
              {validIssueDt && <Input uuid={uuid()} enabled={false} /> }
              {!validIssueDt && <DateField uuid={uuid()} />}
            </Field>
            : <Field width={2} uuid={uuid()} alwaysShowLabel label="pa.issue-date" entry="issueDt" visible={isValidAttachment}>
              <DateField uuid={uuid()} />
            </Field>
          }
          {this.state.editForm
            ? <Field width={3} uuid={uuid()} alwaysShowLabel label="pa.expiration-date" entry="expirationDt" validators={this.getValidatorExpirationDate(isMandatoryExpirationDate, validCheckbox)}>
              {validExpirationDt && <Input uuid={uuid()} enabled={false} />}
              {!validExpirationDt && <DateField uuid={uuid()} />}
            </Field>
            : <Field width={3} uuid={uuid()} alwaysShowLabel label="pa.expiration-date" entry={this.getEntryExpirationDate(validCheckbox)} visible={isValidAttachment}>
              {validCheckbox && <Text value={'pa.undetermined'} />}
              {!validCheckbox && <DateField uuid={uuid()} />}
            </Field>
          }
          <Field width={4} uuid={uuid()} visible = {data.mandatory === 'S' && !data.nrSeqAttachment && !this.state.editForm} >
             <Token value="pa.mandatory" type={Type.NEUTRAL} />
          </Field>
          <Field width={3} uuid={uuid()} entry="ieStatusCheck" alwaysShowLabel visible={this.state.editForm} >
            <Checkbox uuid={uuid()} label="pa.undetermined-validity" enabled={!data.expirationDt ? checkBoxValid : false} name="ieStatusCheck"/> :
          </Field>
          <Field width={3} uuid={uuid()} alwaysShowLabel visible={!isValidAttachment && !this.state.editForm}>
            <Stamp uuid={uuid()} icon={'warning'} color={'safety_orange'} label="pa.status-pending"/>
          </Field>
        </Form>
      </Card>
    );
  }

  onMountDocumentsCard() {
    const { onMountDocumentsCard } = this.props;
    onMountDocumentsCard();
  }

  getSupercriptions() {
    return [
      {
        value: IeStatus.NOT_PENDING,
        color: '#696969',
        label: '',
        icon:'',
      },
      {
        value: IeStatus.PENDING,
        color: '#E65800',
        label: '',
        icon:'',
      },
    ];
  }

  getEntryExpirationDate(validCheckbox) {
    return validCheckbox ? '' : 'expirationDt';
  }

  getValidatorExpirationDate(isValidExpirationDate, validCheckbox) {
    const validator = [];
    if (isValidExpirationDate) {
      validator.push({ name: 'after_current_date' });
      if (!validCheckbox) {
        validator.push({ name: 'required' });
      }
    }
    return validator;
  }

  getValidatorIssueDate(isValidIssueDate) {
    return isValidIssueDate ? [{ name: 'required' }, { name: 'before_current_date' }] : [];
  }

  onChange(event) {
    const { value: formData } = event;
    this.setState({ record: formData });
  }

  onSelect(event) {
    const { value } = event;
    const { nrSeqUser } = HistoryService.getCurrentRouteParams();
    if (value.nrSeqAttachment) {
      ProviderAccreditationFileService.download(nrSeqUser, ieTabela.PROVIDER_ACCREDITATION, value.nrSeqAttachment, value.filename);
    } else if (value.filepath) {
      ProviderAccreditationFileService.preview(value.filepath);
    }
  }

  onSubmit(event) {
    this.setState({ loading: true });
    const { record } = event;
    const data = { ...record };

    const listAttachments = data.attachments;
    let newAttachment = {};

    if (Array.isArray(listAttachments)) {
      listAttachments.forEach((element) => {
        newAttachment = {
          filename: element.filename,
          filepath: element.filepath,
          size: element.size,
        };
        return newAttachment;
      });
    }

    const resultCheckBox = data.ieStatusCheck ? data.ieUndeterminedValidity = IeUndeterminedValidity.MARKED : data.ieUndeterminedValidity = IeUndeterminedValidity.UNMARKED;
    const { nrSeqUser, nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    const body = { newAttachment, ...data };
    body.ieUndeterminedValidity = resultCheckBox;

    HttpService.post(Endpoint.POST.SEND_DOCUMENT, { nrSeqUser, nrSeqAccreditation }, { body })
    .then(() => {
      this.onAfterSubmit();
    }).catch(() => {
      this.setState({ loading: false });
      ToastServiceProviderAccreditation.error('pa.error-process-request')
    });
  }

  onCancel() {
    this.setState({ editForm: false })
    const { onAfterSubmitDocumentsCard } = this.props;
    onAfterSubmitDocumentsCard();
  }

  onAfterSubmit() {
    const { onAfterSubmitDocumentsCard } = this.props;
    onAfterSubmitDocumentsCard();
  }

  render() {
    return this.renderCard();
  }
}
